import React from 'react';
import { Experience } from '../types/Experience';
import { ExperienceCategorySection } from './ExperienceCategorySection';
interface ExperiencesListProps {
  experiences: Experience[];
  selectedExperienceId: string | null;
  onSelectExperience: (id: string) => void;
}
export function ExperiencesList({
  experiences,
  selectedExperienceId,
  onSelectExperience
}: ExperiencesListProps) {
  // Group experiences by category
  const categorizedExperiences = experiences.reduce((acc, experience) => {
    const category = experience.category || 'Altro';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(experience);
    return acc;
  }, {} as Record<string, Experience[]>);
  const categories = Object.keys(categorizedExperiences).sort();
  return <div className="h-full overflow-y-auto bg-white" data-id="element-157">
      {categories.map(category => <ExperienceCategorySection key={category} category={category} experiences={categorizedExperiences[category]} selectedExperienceId={selectedExperienceId} onSelectExperience={onSelectExperience} data-id="element-158" />)}
    </div>;
}